import * as React from 'react';
import Alert from '@mui/material/Alert';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

import { ApiClient } from '../../../lib/ApiClient';
import { useAuthenticated } from '../../auth/useAuthenticated'
import { useDomainNavigate } from '../../../domain';

const apiClient = new ApiClient();

export default function ErrorConfirmEmail() {
    let navigate = useDomainNavigate();

    const userAuth = useAuthenticated(apiClient);

    if (!userAuth.isAuthenticating && !userAuth.isAuthenticated) {
        navigate("/account/login");
    }
    else if (userAuth.isAuthenticated && userAuth.result.emailConfirmed)
    {
        navigate("/account/logout");
    }

    return (
        <>
            <Box
                sx={{
                    marginTop: 0,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
            >
                <Alert severity="error" sx={{mt: 2}}>
                    <Typography variant="p" gutterBottom component="div">
                        <strong>The email address associated with account has not been confirmed.</strong>
                    </Typography>
                    <Typography variant="p" gutterBottom component="div">
                        Click the link in the email confirmation that was sent to you in order to proceed.
                    </Typography>
                </Alert>

            </Box>
        </>
    );
}